<template>
  <v-dialog
    v-model="agregarDatoLaboralDialog"
    width="40%"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="secondary"
        class="d-inline ml-4"
        v-bind="attrs"
        v-on="on"
        @click="agregarDatoLaboralDialog = true"
      >
        Agregar dato laboral
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Nuevo dato laboral
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="agregarDatoLaboralDialog = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="datoLaboralForm"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="datoLaboral.empresa"
                  label="Empresa"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="datoLaboral.puesto"
                  label="Puesto"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="datoLaboral.periodo"
                  label="Periodo"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="datoLaboral.motivoConclusion"
                  label="Motivo de conclusión"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="!datoLaboralForm || loading"
          @click="triggerSaveDatoLaboral()"
        >
          Guardar dato laboral
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    idExpediente: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      agregarDatoLaboralDialog: false,

      datoLaboralForm: false,
      loading: false,

      datoLaboral: {
        fk_idExpediente: this.idExpediente,
        empresa: '',
        puesto: '',
        periodo: '',
        motivoConclusion: '',
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  methods: {
    ...mapActions('datosLaborales', ['saveDatosLaborales', 'fetchDatosLaborales']),

    async triggerSaveDatoLaboral() {
      this.loading = true;

      await this.saveDatosLaborales(this.datoLaboral);

      this.closeDialog();
    },

    async closeDialog() {
      this.loading = false;
      this.datoLaboral = {
        fk_idExpediente: this.idExpediente,
        empresa: '',
        puesto: '',
        periodo: '',
        motivoConclusion: '',
      };
      this.agregarDatoLaboralDialog = false;
      this.$refs.form.resetValidation();
      await this.fetchDatosLaborales(this.idExpediente);
    },
  },
};
</script>
